export const BrandAssets = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Brand Assets</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Design pending...</p>
      </div>
    </div>
  );
};
